import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const OurAlumni = () => {
  return (
    <>
       <Breadcrumb 
            pageTitle="Our Alumni"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Our Alumni" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
       <section class="space-ptb">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-12">
            <div class="section-title mb-4 pr-lg-5 px-4 px-lg-2">
              <h2 class="title"><span class="text-primary">Our Alumni</span></h2>
                <div className="curved-line mx-auto mt-3"></div>
            </div>            
          </div>          
        </div>
         <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 mb-4 mb-md-0">
            <div class="team">
              <div class="team-img">
                <img class="img-fluid" src="images/Alumni-04.jpg" alt="" />
              </div>
              <div class="team-info">
                <a href="teachers-single.html" class="team-name">Ayushi Goswami</a>
                <p class="team-leader">Civil Judge</p>                       
              </div>
            </div>
            
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 mb-4 mb-md-0">
            <div class="team">
              <div class="team-img">
                <img class="img-fluid" src="images/Alumni-03.jpg" alt="" />
              </div>
              <div class="team-info">
                <a href="teachers-single.html" class="team-name">Lalit Yadav</a>
                <p class="team-leader">Doctor</p>                       
              </div>
            </div>
            
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 mb-4 mb-md-0">
            <div class="team">
              <div class="team-img">
                <img class="img-fluid" src="images/Alumni-05.jpg" alt="" />
              </div>
              <div class="team-info">
                <a href="teachers-single.html" class="team-name">Doctor</a>
                <p class="team-leader">Dhruv Lahri</p>                       
              </div>
            </div>
            
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 mb-4 mb-md-0">
            <div class="team">
              <div class="team-img">
                <img class="img-fluid" src="images/Alumni-01.jpg" alt="" />
              </div>
              <div class="team-info">
                <a href="teachers-single.html" class="team-name">Archana Verma</a>
                <p class="team-leader">IAS</p>                       
              </div>
            </div>
            
          </div>
          </div>
      </div>
    </section>
    </>
  )
}

export default OurAlumni
